// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Record from "../Record/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var set = /* #__PURE__ */ Specular_Ref.set(Effect_Class.monadEffectEffect);
var dynamicFixRecord = function (dict) {
    return dict.dynamicFixRecord;
};
var fixFRPRecord = function (dictDynamicFixFRPRecord) {
    var dynamicFixRecord1 = dynamicFixRecord(dictDynamicFixFRPRecord);
    return function () {
        return {
            dynamicFixFRP: function (dictMonadFRP) {
                return dynamicFixRecord1(dictMonadFRP)(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var dynamicFixFRPRecordNil = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        dynamicFixRecord: function (dictMonadFRP) {
            var map = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0());
            return function (v) {
                return function (v1) {
                    return function (f) {
                        return map(Data_Tuple.snd)(f(to({})));
                    };
                };
            };
        }
    };
};
var dynamicFixFRPDynamic = {
    dynamicFixFRP: function (dictMonadFRP) {
        var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
        var Bind1 = Monad0.Bind1();
        var bind = Control_Bind.bind(Bind1);
        var $$new = Specular_Ref["new"](dictMonadFRP.MonadEffect0());
        var discard1 = discard(Bind1);
        var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
        var pure = Control_Applicative.pure(Monad0.Applicative0());
        return function (initial) {
            return function (callback) {
                return bind($$new(initial))(function (ref) {
                    return bind(callback(Specular_Ref.value(ref)))(function (v) {
                        return discard1(subscribeDyn_(set(ref))(v.value0))(function () {
                            return pure(v.value1);
                        });
                    });
                });
            };
        };
    }
};
var dynamicFixFRP = function (dict) {
    return dict.dynamicFixFRP;
};
var dynamicFixFRPRecord = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    var $$delete = Record["delete"](dictIsSymbol)()();
    var insert = Record.insert(dictIsSymbol)()();
    return function () {
        return function () {
            return function () {
                return function () {
                    return function (dictDynamicFixFRP) {
                        var dynamicFixFRP1 = dynamicFixFRP(dictDynamicFixFRP);
                        return function (dictDynamicFixFRPRecord) {
                            var dynamicFixRecord1 = dynamicFixRecord(dictDynamicFixFRPRecord);
                            return {
                                dynamicFixRecord: function (dictMonadFRP) {
                                    var dynamicFixFRP2 = dynamicFixFRP1(dictMonadFRP);
                                    var dynamicFixRecord2 = dynamicFixRecord1(dictMonadFRP);
                                    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
                                    var bind = Control_Bind.bind(Monad0.Bind1());
                                    var pure = Control_Applicative.pure(Monad0.Applicative0());
                                    return function (v) {
                                        return function (initial) {
                                            return function (f) {
                                                return dynamicFixFRP2(get(Type_Proxy["Proxy"].value)(initial))(function (v1) {
                                                    return dynamicFixRecord2(Type_Proxy["Proxy"].value)($$delete(Type_Proxy["Proxy"].value)(initial))(function (v2) {
                                                        var roi = insert(Type_Proxy["Proxy"].value)(v1)(v2);
                                                        return bind(f(roi))(function (v3) {
                                                            var output = get(Type_Proxy["Proxy"].value)(v3.value0);
                                                            var tail_ro = $$delete(Type_Proxy["Proxy"].value)(v3.value0);
                                                            return pure(new Data_Tuple.Tuple(tail_ro, new Data_Tuple.Tuple(output, v3.value1)));
                                                        });
                                                    });
                                                });
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
export {
    dynamicFixFRP,
    dynamicFixRecord,
    dynamicFixFRPDynamic,
    fixFRPRecord,
    dynamicFixFRPRecordNil,
    dynamicFixFRPRecord
};
